import initFullStory from 'services/fullstory';
import { isHostedPagePreview } from 'utilities/global';

export { Tracker } from 'shared/services/tracking';

export const initAnalytics = ({ fullstory_org_id: fullStoryOrgId }) => {
  const isPreview = isHostedPagePreview();
  if (isPreview) return;

  initFullStory({ fullStoryOrgId });
};
